export class FailLevelScene extends Phaser.Scene {
    private mBackground: Phaser.GameObjects.Image;

    private mLosingText: Phaser.GameObjects.Text;
    private mGoBackText: Phaser.GameObjects.Text;
    private mGoldLost: number;
    private mStorage: Storage;

    constructor() {
        super('FailLevelScene')
    }

    init(obj) {
        this.mGoldLost = obj.LostGold;
    }

    preload() {
        this.load.image('loseBackground', 'images/Scenes/LoseScene.png');
    }

    create() {
        console.log(`Gold lost ${this.mGoldLost}`);

        let width = this.cameras.main.width;
        let height = this.cameras.main.height;
        this.mBackground = this.add.image(width / 2, height / 2, "loseBackground");
        this.mBackground.setDisplaySize(width, height);
        this.mBackground.setDepth(-1);

        this.mLosingText = this.add.text(20, 100, `You lost  ${this.mGoldLost} gold`, { fontSize: "50px", color: `0xffffff` });
        this.mGoBackText = this.add.text(20, 200, 'Back To Story', { fontSize: "50px", color: `0xffffff` })
            .setInteractive()
            .on('pointerdown', () => {
                this.cameras.main.fade(100);
                this.time.delayedCall(100, () => {
                    this.scene.transition({
                        target: "SelectLevelScene",
                        duration: 200,
                        sleep: true,
                        remove: false,
                    });
                });
            });
    };
}